function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import CareersComponent from "components/pages/careers/careers-component";
import ErrorCareersComponent from "components/pages/careers/error-careers-component/error-careers-component";
import { getDataFromComeet } from "/server/services/comeet-service/comeet-service";
import { CAREERS_ERROR_RENDERED } from "/constants/bigbrain-event-types";
import { CAREERS_PAGE } from "/constants/careers/careers";
import { filterByPositionType } from "components/pages/careers/careers-service";
import BaseTemplatePage from "../../generated-templates/base-template-page";
import { InternalServerError } from "server/extensions/error-extensions";
import { INTERNAL_SERVER_ERROR_CODE } from "constants/status-codes";
import { getGeneratorSystemConfigOnRequest } from "server/services/request-service/request-service";
class CareersPage extends BaseTemplatePage {
    static getInitialProps({ req, res, asPath, query }) {
        return _async_to_generator(function*() {
            const { handleServerException } = require("../../../server/services/exceptions-handling-service/exceptions-handling-service");
            const superInitialProps = yield BaseTemplatePage.getInitialProps({
                req,
                res,
                asPath
            });
            const { translations, isMobileOrTabletBrowser, cloudfrontViewerCountry } = superInitialProps;
            const { positionsType } = query;
            try {
                var _getGeneratorSystemConfigOnRequest;
                const allPositionsData = yield getDataFromComeet();
                if (!allPositionsData || allPositionsData.ERROR) {
                    throw new InternalServerError("error fetching positions data");
                }
                const positionsData = filterByPositionType(allPositionsData, positionsType);
                return {
                    positionsData,
                    translations,
                    asPath,
                    isTypeformDisabled: (_getGeneratorSystemConfigOnRequest = getGeneratorSystemConfigOnRequest(req)) === null || _getGeneratorSystemConfigOnRequest === void 0 ? void 0 : _getGeneratorSystemConfigOnRequest.isTypeformDisabled,
                    positionsType,
                    isMobileOrTabletBrowser,
                    cloudfrontViewerCountry
                };
            } catch (e) {
                yield handleServerException({
                    e,
                    req,
                    res,
                    bbEventParams: {
                        name: CAREERS_ERROR_RENDERED,
                        kind: CAREERS_PAGE
                    }
                });
                res.statusCode = INTERNAL_SERVER_ERROR_CODE;
                return {
                    translations
                };
            }
        })();
    }
    render() {
        const { positionsData, translations } = this.props;
        if (!positionsData) return /*#__PURE__*/ _jsx(ErrorCareersComponent, {
            translations: translations
        });
        return /*#__PURE__*/ _jsx(CareersComponent, _object_spread({}, this.props));
    }
}
export { CareersPage as default };
